<template>
  <div class="searchMain">
    <div class="content">
      <div class="searchHead">
        <el-input
          placeholder="请输入内容"
          class="input-with-select"
          v-model="form.search"
          @keyup.enter.native="searchFun"
          size="large"
          style="width:500px;"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchFun"
          ></el-button>
        </el-input>
        <el-form :model="form" :inline="true" class="demo-form-inline">
          <el-form-item label="关键词位置：">
            <el-select
              placeholder="请选择"
              v-model="form.keywordPosition"
              size="mini"
              style="width:150px;"
            >
              <el-option label="所有栏目" value="0"></el-option>
              <el-option label="标题" value="1"></el-option>
              <el-option label="文章" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="栏目：">
            <el-cascader
              clearable
              v-model="form.section"
              size="mini"
              :options="typeList"
              :show-all-levels="false"
              :props="{
                value: 'id',
                label: 'typeName',
                children: 'childType',
                expandTrigger: 'hover',
                disabled: 'disabled',
                emitPath: false,
              }"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="时间：">
            <el-date-picker
              v-model="form.startTime"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              style="width:140px;"
              placeholder="选择日期"
            >
            </el-date-picker>
            <span style="margin: 0 10px;">至</span>
            <el-date-picker
              v-model="form.endTime"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              style="width:140px;"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="排序：">
            <el-select
              placeholder="请选择"
              v-model="form.orderType"
              size="mini"
              style="width:150px;"
            >
              <el-option label="按相关度" value="0"></el-option>
              <el-option label="按发布时间升序" value="1"></el-option>
              <el-option label="按发布时间降序" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="searchList">
        <el-empty
          :image-size="200"
          v-if="list.length == 0"
          style="margin-top:200px;"
        ></el-empty>
        <div v-for="(item, index) in list" v-else :key="index" class="item">
          <div class="title" v-html="replaceText(item.title)" @click="toArtical(item)"></div>
          <div v-if="item.introduce">{{ item.introduce }}</div>
          <div>
            <span class="time">{{ item.createTime }}</span>
            <span class="type" @click="toType(item)">{{ getName(item.typeOneName,'1')}}</span>
            <span> > </span>
            <span class="type" @click="toType(item)">{{ getName(item.type,'2') }}</span>
          </div>
        </div>
      </div>
      <div style="margin-top:30px;">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :current-page="form.page + 1"
          :total="totalNum"
          hide-on-single-page
          @current-change="currentChange"
          :page-size="form.size"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { findType, searchArticle } from "@/api/main";
export default {
  name: "Search",
  props: {
    tabsTypeName: String,
    tabsTypeId: String,
  },
  data() {
    return {
      typeList: [],
      typeTwoList: [],
      list: [],
      form: {
        endTime: null,
        keywordPosition: "0",
        orderType: "0",
        page: 0,
        search: "",
        section: null,
        size: 10,
        startTime: null,
      },
      totalNum: 0,
    };
  },
  mounted() {
    document.title = '搜索'
    this.getType();
    if (this.$route.query.key) {
      this.form.search = this.$route.query.key;
    }
    this.searchFun();
  },
  watch: {},
  methods: {
    //关键词高亮
    replaceText(value) {
			return value.replace(this.form.search, `<font style='color: #cc0000'>${this.form.search}</font>`);
		},
    searchFun() {
      searchArticle(this.form).then((res) => {
        this.list = res.data.content;
        this.totalNum = res.data.totalElements;
      });
    },
    toArtical(item){
      var path = item.deptId == 100 ? '/Content': '/committee/Content'
      var routeData =  this.$router.resolve({
        path: path,
        query: {
          type:this.getName(item.typeOneName,'1'),
          typeId:item.typeOneName,
          articleId: item.id
        }
      });

      if (!item.url) {
        window.open(routeData.href, "_blank");
      } else {
        var fileName = item.url.substring(item.url.lastIndexOf(".") + 1);
        if (["pdf", "doc", "docx"].includes(fileName)) {
          window.open(item.url);
        } else {
          window.open(routeData.href, "_blank");
        }
      }
    },
    toType(item){
      var path = item.deptId == 100 ? '/Content': '/committee/Content'
      var routeData =  this.$router.resolve({
        path: path,
        query: {
          type:this.getName(item.typeOneName,'1'),
          typeId:item.typeOneName
        }
      });
      window.open(routeData.href, '_blank');
    },
    getType() {
      findType().then((res) => {
        this.typeList = res.data;
        var list = []
        this.typeList.map(el=>{
          if(el.childType){
            list = list.concat(el.childType)
          }
        })
        this.typeTwoList = list
      });
    },
    currentChange(page) {
      this.form.page = page - 1;
      this.searchFun();
    },
    getName(id, position) {
      if (position == "1") {
        var Name = this.typeList.find(el => {
          return el.id == id
        });
        if (Name) {
          return Name.typeName;
        } else {
          return "";
        }
      }
      if (position == "2") {
        var Name = this.typeTwoList.find(el => {
          return el.id == id
        });
        if (Name) {
          return Name.typeName;
        } else {
          return "";
        }
      }
    },
  },
};
</script>

<style>
/* 整体样式 */
.searchMain {
  width: 100%;
  padding-bottom: 20px;
  background-color: #fff;
  background: url("http://www.carec.org.cn/template/1/xh/_files/images/index_bg.jpg")
    no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: 100% 100%;
}
.searchMain .content {
  width: 1200px;
  margin: 0 auto;
  min-height: 800px;
  padding: 20px;
}
.searchMain .content .searchList .item {
  padding: 8px;
  font-size: 16px;
  border-bottom: 1px solid #ccc;
}
.searchMain .content .searchList .item .title {
  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;
  color: #00c;
}
.searchMain .content .searchList .item .time {
  color: #008000;
  margin-right: 15px;
}
.searchMain .content .searchList .item .type {
  cursor: pointer;
  color: #555;
}
</style>
